<template>
    <section id="wrapper-body" class="bg-page">
        <section class="wrap-box">



            <a href="#" class="btn_gotop">
                <img src="/img/main/totop.png"  class="img w-100 " alt="" />
            </a>

            
            <DarkHeader  v-if="this.scrollTop == 0 && ($route.fullPath == '/'|| $route.fullPath.includes('section') ) && !isMobile()"/>
            <LightHeader  v-else/>
            
            <router-view/>

            <footer class="footer">
                <div class="wrap-content">
                    <div class="container text-white">
                        <div class="d-flex">
                            <img src="/img/brand/new_logo.png" class="logo" alt="">
                        </div>
                        
                        <div class="d-flex justify-content-between font-size-80 mt-3">
                            <div class="info-wrap">
                                <div class="info-item">
                                    <div><a class="footer-link" href=" https://echelonbiz.co.kr/" target="_blank">ECHELON BIZ</a></div>
                                </div>
                                <div class="info-item">
                                    <div><a class="footer-link" href="https://echelon.co.kr" target="_blank">애슐런컴퍼니</a></div>
                                </div>
                                <div class="info-item">
                                    <div><a class="footer-link" href="https://fren.co.kr/fren-english" target="_blank">프렌잉글리시</a></div>
                                </div>
                                <div class="info-item">
                                    <div><a class="footer-link" href="https://fren.co.kr/fren-math" target="_blank">프렌매쓰</a></div>
                                </div>
                                <div class="info-item">
                                    <div><a class="footer-link" href="https://home-learnclass.co.kr/" target="_blank">홈런 스마트클래스</a></div>
                                </div>
                                <div class="info-item">
                                    <div><a class="footer-link" href="https://mhsrclass.com/" target="_blank">문해와수리</a></div>
                                </div>
                            </div>
                        </div>
                        <div class="row mt-3">
                            <div class="col-12">
                                <div class="info-wrap pt-3 max-w-750px">
                                    <div class="info-item font-weight-bold">
                                        <div>(주)애슐런컴퍼니(ECHELON COMPANY)</div>
                                    </div>
                                    <!-- <div class="info-item font-weight-bold">
                                        <div>(주)모든교육</div>
                                    </div> -->
                                    <!-- <div class="info-item font-weight-bold">
                                        <div>수학여우</div>
                                    </div> -->
                                    <div class="info-item">
                                        <label>대표이사:</label>
                                        <div>김성운</div>
                                    </div>
                                    <div class="info-item">
                                        <label>사업자등록번호</label>
                                        <div>768-81-02175</div>
                                    </div>
                                    <!-- <div class="info-item">
                                        <label>통신판매업 신고번호</label>
                                        <div>제2016-성남중원-0261호</div>
                                    </div> -->
                                </div>
                                <div class="info-wrap">
                                    <div class="info-item">
                                        <label>통신판매업번호: </label>
                                        <div>제 2021-서울성동-01819호</div>
                                    </div>
                                </div>
                                <div class="info-wrap">
                                    <div class="info-item">
                                        <label>주소: </label>
                                        <div>경기도 하남시 미사대로 540 현대지식산업센터 한강미사 2차 A동 409호~410호</div>
                                    </div>
                                    <div class="info-item">
                                        <label>대표번호</label>
                                        <div>1577-0910</div>
                                    </div>
                                </div>
                                <div class="info-wrap pb-3 max-w-750px">
                                    <div class="info-item">
                                        <label>&copy;</label>
                                        <div>2023 MATHFOX. All Right Reserved.</div>
                                    </div>
                                </div>
                                <div class="btn-info-item">
                                    <a href="#">개인보호정책</a>
                                    <a href="#">이용약관</a>
                                    <div>가맹상담 &nbsp; <span style="font-size: 18pt;">1577-0910</span></div>
                                </div>
                            </div>
                        </div>
                        <div class="d-flex justify-content-between font-size-80 mt-2">
                            <div class="info-wrap">
                                <div class="info-item">
                                    <div>
                                        <a href="https://www.instagram.com/mathfox_official/" target="_blank">
                                            <!-- <img src="/img/common/instagram_logo_icon.svg" class="w-7 h-7"/> -->
                                            <icon-base
                                                viewBox="0 0 40 40"
                                                width="40"
                                                height="40"
                                                iconColor="#fff"
                                                icon-name="instagram"
                                            >
                                                <icon-instagram></icon-instagram>
                                            </icon-base>
                                        </a>
                                    </div>
                                    <div>
                                        <a href="https://blog.naver.com/victorywan1" target="_blank">
                                            <!-- <img src="/img/common/instagram_logo_icon.svg" class="w-7 h-7"/> -->
                                            <icon-base
                                                viewBox="0 0 132.97 132.98"
                                                width="24"
                                                height="40"
                                                icon-name="instagram"
                                            >
                                                <icon-naver-blog 
                                                    color1="#fff"
                                                    color2="#0093c3"
                                                />
                                            </icon-base>
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!-- <div class="d-flex justify-content-between font-size-80 mt-8">
                            <div class="copyright">
                                (c)2009  류연우논리수학(모든교육) All right reserved.
                            </div>
                            <div class="copyright">
                                Copyrights 2018 수학여우. All rights reserved.
                            </div>
                        </div> -->
                    </div>
                </div>
            </footer>


        </section>
    </section>
</template>

<script>
import LightHeader from './components/LightHeader.vue'
import DarkHeader from './components/DarkHeader.vue'
import IconBase from '@/components/IconBase.vue'
import IconInstagram from './components/icons/iconInstagram.vue'
import IconNaverBlog from './components/icons/iconNaverBlog.vue'
export default {
    name: 'App',
    components: {
        IconBase,
        IconInstagram,
        IconNaverBlog,
        LightHeader,
        DarkHeader,
    },
    data() {
      return {
        scrollTop: 0,
      };
   },
    // 1번 가상 돔 마운트 시, 이벤트 등록
    mounted() {
      document.addEventListener('scroll', this.handleScroll);
   },

   // 3번 마운트 해제 전, 이벤트 삭제하기
   beforeUnmount() {
     document.removeEventListener('scroll', this.handleScroll);
   },
    methods: {
        isMobile() {
            if(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
                return true
            } else {
                return false
            }
        },
      handleScroll: function (e) {
        this.scrollTop = document.documentElement.scrollTop;
        //console.log(this.scrollTop);
      }
    },
}
</script>

<style>
@media (max-width: 991.99px) {
    .top-nav-wrap {
        top: 110px;
        height: calc(100vh - 110px);
    }
}
.nav-item.active .nav-link, .nav-link.active {
    color: white;
}
.footer-link {
    color: #fff;
}
.footer-link:hover {
    color: #ff946e;
}
.dropDownMenuWrapper {
    border: none !important;
    width: 150px !important;
    height: 49px !important;
    box-shadow: none !important;
    background: transparent !important;
}
.dropDownMenuWrapper .iconWrapper {
    display: none !important;
}
.dropDownMenuWrapper .dropDownMenuButton {
    padding: 0 !important;
    color: inherit;
}
</style>
